import { styled } from "@mui/material";
import { colors } from "@zapalacorp/tokens";

export const TextButtonWrapper = styled("div")<{ $disabled?: boolean }>(({ $disabled }) => ({
  display: "flex",
  padding: "10px 12px",
  justifyContent: "center",
  alignItems: "center",
  width: "fit-content",
  gap: "8px",
  flex: "1 0 0",
  borderRadius: "8px",
  alignSelf: "stretch",
  cursor: $disabled ? "not-allowed" : "pointer",
  transition: "background-color 0.2s ease",
  "&:hover": {
    backgroundColor: $disabled ? "transparent" : "rgba(0, 85, 164, 0.08)", // #0055A414
  },
  "&:focus, &:active": {
    backgroundColor: $disabled ? "transparent" : "rgba(0, 85, 164, 0.12)", // #0055A41F
  },
  "&:focus": {
    outline: "none",
  },
}));

export const TextButtonTypography = styled("div")({
  color: colors.brandBlue500,
  textAlign: "center",
  fontFamily: "Manrope",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: 600,
  lineHeight: "20px",
  letterSpacing: "0.1px",
});
